// 9fbef606107a605d69c0edbcd8029e5d
const CUSTOMNAVIGATION_CONSTANTS = {
  CUSTOM_NAVIGATE_TO: 'CUSTOM_NAVIGATE_TO',
  IS_BOOTSTRAP_DONE: 'IS_BOOTSTRAP_DONE',
  IS_NAVIGATIONDATA_DONE: 'IS_NAVIGATIONDATA_DONE',
  IS_NAVIGATE: 'IS_NAVIGATE',
  URL_PREFIX: '/c?cid=',
  PAGE_SEARCH: 'search',
  PAGE_BAG: 'bag',
  PAGE_ACCOUNT: 'account',
  PAGE_PLP: 'plp',
  PAGE_PDP: 'pdp',
  PAGE_OUTFIT: 'outfit',
  PLCC_CARD: 'plcc-card',
  MYPLACEREWARDSCCPAGEMOBILE: 'myPlaceRewardsCCPageMobile',
  FAVORITE: 'favorite',
  MYFAVORITEPAGEMOBILE: 'myFavoritePageMobile',
  CATEGORY: 'category',
  IS_APP_LAUNCH: 'IS_APP_LAUNCH',
  PAGE_ORDERDETAIL: 'order',
  NAVIGATION_DEEPLINK_URL: 'NAVIGATION_DEEPLINK_URL',
};

export default CUSTOMNAVIGATION_CONSTANTS;
